import { render, staticRenderFns } from "./ranfs.vue?vue&type=template&id=54dd2a79&"
import script from "./ranfs.vue?vue&type=script&lang=js&"
export * from "./ranfs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports